
const TokenKey = 'access-token'
const reshToken = 'x-access-token'
const UIF = 'USER_INFO'
const CER = 'ISCERTIFIED'

// token
export function getToken() {
  return window.localStorage.getItem(TokenKey)
}

export function setToken(value) {
  return window.localStorage.setItem(TokenKey, value)
}

export function deleteToken() {
  return window.localStorage.removeItem(TokenKey)
}
// reshtoken
export function getReshToken() {
  return window.localStorage.getItem(reshToken)
}

export function setReshToken(value) {
  return window.localStorage.setItem(reshToken, value)
}

export function deleteReshToken() {
  return window.localStorage.removeItem(reshToken)
}

//userinfo

export function getUserInfo() {
  const UINFO = window.localStorage.getItem(UIF)
  if (UINFO !== '' && UINFO !== undefined && UINFO !== null) {
    return JSON.parse(UINFO)
  } else {
    return ''
  }
}

export function setUserInfo(UserIn) {
  if(typeof UserIn !== 'string'){
    return window.localStorage.setItem(UIF, JSON.stringify(UserIn))
  } else {
    return window.localStorage.setItem(UIF, UserIn)
  }
}

export function removeUserInfo() {
  return window.localStorage.removeItem(UIF)
}

// cer
export function getCer() {
  let result = window.localStorage.getItem(CER)
  if(result!== undefined && result!== null &&result!==''){
    return JSON.parse(window.localStorage.getItem(CER))
  } else {
    return ''
  }
  // return window.localStorage.getItem(CER)
}

export function setCer(value) {
  return window.localStorage.setItem(CER, value)
}

export function deleteCer() {
  return window.localStorage.removeItem(CER)
}
